<div class="loading-overlay" *ngIf="isLoading">
  <mat-progress-spinner mode="indeterminate" color="primary"></mat-progress-spinner>
</div>

<div class="warn-dialog">
  <div class="title">
    <p>Selecionar empresa</p>
    <mat-icon style="cursor: pointer; color: #5f6368" (click)="onCancel()"
      >close</mat-icon
    >
  </div>

  <hr />

  <div class="aviso-container">
    <div class="icone-aviso">
      <img alt="aviso" src="../../../../../assets/svg/icons/warning.svg">
    </div>

    <div class="texto-aviso">
      <p class="titulo-aviso">Algumas empresas não podem ser desmarcadas</p>
      <p class="conteudo-aviso">Essas empresas pertencem aos grupos selecionados e, por isso,
        não podem ser desmarcadas individualmente. Para removê-las,
        é necessário excluir o grupo deste disparo de aviso.</p>
    </div>
  </div>

  <div class="content">
    <mat-form-field appearance="outline" class="search-field">
      <mat-label>Buscar por nome</mat-label>
      <img matPrefix src="../../../../../assets/svg/icons/search.svg" alt="Lupa" class="search-icon" />
      <input
        matInput
        type="text"
        placeholder=" "
        (input)="updateFieldText($event)"
      />
    </mat-form-field>

    <div *ngFor="let empresa of listaDeEmpresas" class="grupo-checkbox">
      <div class="container-nome">
        <mat-checkbox
          [checked]="empresaBloqueada(empresa) || getCheckboxState(empresa).checked"
          [indeterminate]="!empresaBloqueada(empresa) && getCheckboxState(empresa).indeterminate"
          [disabled]="empresaBloqueada(empresa)"
          (change)="toggleGrupo(empresa, $event.checked)">
        </mat-checkbox>

        <p class="nome">{{empresa.nome}}</p>
      </div>

      <hr />

      <div class="container-usuarios container-checkbox-cinza">
        <p class="selecao-destinatarios">Destinatário:</p>
        <mat-checkbox
          [(ngModel)]="empresa.buscaPessoas"
          [disabled]="empresaBloqueada(empresa)"
          [checked]="empresaBloqueada(empresa) || empresa.buscaPessoas"
          (change)="onToggleFilho(empresa)">
        </mat-checkbox>

        <p class="tag-select">Pessoas do grupo</p>

        <mat-checkbox
          [(ngModel)]="empresa.buscaUsuarios"
          [disabled]="empresaBloqueada(empresa)"
          [checked]="empresaBloqueada(empresa) || empresa.buscaUsuarios"
          (change)="onToggleFilho(empresa)">
        </mat-checkbox>

        <p class="tag-select">Usuários do grupo</p>

      </div>
    </div>
  </div>

  <hr />

  <div class="modal-footer" mat-dialog-actions>
    <button matButton="filled" (click)="onConfirm()">Confirmar e selecionar</button>
  </div>
</div>
